/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 商家列表|导出 的 **请求配置**
 *
 * @分类 4139
 * @请求头 `POST /erp/supply/SupplyList`
 */
const postSupplyListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/supply/SupplyList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSupplyList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家列表|导出 的 **请求函数**
 *
 * @分类 4139
 * @请求头 `POST /erp/supply/SupplyList`
 */
export const postSupplyList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSupplyListRequestConfig, requestData), ...args);
};
postSupplyList.requestConfig = postSupplyListRequestConfig;
/**
 * 接口 编辑商家信息 的 **请求配置**
 *
 * @分类 4139
 * @请求头 `POST /erp/supply/UpdateSupply`
 */
const postUpdateSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/supply/UpdateSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdateSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 编辑商家信息 的 **请求函数**
 *
 * @分类 4139
 * @请求头 `POST /erp/supply/UpdateSupply`
 */
export const postUpdateSupply = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postUpdateSupplyRequestConfig, requestData), ...args);
};
postUpdateSupply.requestConfig = postUpdateSupplyRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 修改供应商状态 的 **请求配置**
 *
 * @分类 #4185
 * @请求头 `POST /erp/Supply/UpdateSingleSupplyStatus`
 */
const postUpdateSingleSupplyStatusRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Supply/UpdateSingleSupplyStatus",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdateSingleSupplyStatus",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 修改供应商状态 的 **请求函数**
 *
 * @分类 #4185
 * @请求头 `POST /erp/Supply/UpdateSingleSupplyStatus`
 */
export const postUpdateSingleSupplyStatus = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postUpdateSingleSupplyStatusRequestConfig, requestData),
    ...args
  );
};
postUpdateSingleSupplyStatus.requestConfig =
  postUpdateSingleSupplyStatusRequestConfig;
/**
 * 接口 批量更新供应商状态 的 **请求配置**
 *
 * @分类 #4185
 * @请求头 `POST /erp/Supply/batchUpdateSupply`
 */
const postBatchUpdateSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Supply/batchUpdateSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchUpdateSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量更新供应商状态 的 **请求函数**
 *
 * @分类 #4185
 * @请求头 `POST /erp/Supply/batchUpdateSupply`
 */
export const postBatchUpdateSupply = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postBatchUpdateSupplyRequestConfig, requestData),
    ...args
  );
};
postBatchUpdateSupply.requestConfig = postBatchUpdateSupplyRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 包裹详情 的 **请求配置**
 *
 * @分类 4.57.0
 * @请求头 `POST /erp/Supply/packageDetail`
 */
const postPackageDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/packageDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPackageDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 包裹详情 的 **请求函数**
 *
 * @分类 4.57.0
 * @请求头 `POST /erp/Supply/packageDetail`
 */
export const postPackageDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postPackageDetailRequestConfig, requestData), ...args);
};
postPackageDetail.requestConfig = postPackageDetailRequestConfig;
const mockUrl_0_0_0_3 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_3 = "";
const prodUrl_0_0_0_3 = "";
const dataKey_0_0_0_3 = "data";
/**
 * 接口 档口收包记录列表 的 **请求配置**
 *
 * @分类 采购工作台(不含触达，开单)
 * @请求头 `POST /erp/Supply/supplyPackageList`
 */
const postSupplyPackageListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/Supply/supplyPackageList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSupplyPackageList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 档口收包记录列表 的 **请求函数**
 *
 * @分类 采购工作台(不含触达，开单)
 * @请求头 `POST /erp/Supply/supplyPackageList`
 */
export const postSupplyPackageList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSupplyPackageListRequestConfig, requestData),
    ...args
  );
};
postSupplyPackageList.requestConfig = postSupplyPackageListRequestConfig;
const mockUrl_0_0_0_4 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_4 = "";
const prodUrl_0_0_0_4 = "";
const dataKey_0_0_0_4 = "data";
/**
 * 接口 档口收包详情-作废 的 **请求配置**
 *
 * @分类 #5803
 * @请求头 `POST /erp/Supply/wasteSupplyPackage`
 */
const postWasteSupplyPackageRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Supply/wasteSupplyPackage",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postWasteSupplyPackage",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 档口收包详情-作废 的 **请求函数**
 *
 * @分类 #5803
 * @请求头 `POST /erp/Supply/wasteSupplyPackage`
 */
export const postWasteSupplyPackage = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postWasteSupplyPackageRequestConfig, requestData),
    ...args
  );
};
postWasteSupplyPackage.requestConfig = postWasteSupplyPackageRequestConfig;
const mockUrl_0_0_0_5 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_5 = "";
const prodUrl_0_0_0_5 = "";
const dataKey_0_0_0_5 = "data";
/**
 * 接口 供应商列表 的 **请求配置**
 *
 * @分类 退换货是否接收
 * @请求头 `GET /erp/Supply/SupplyList`
 */
const getSupplyListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_5,
  devUrl: devUrl_0_0_0_5,
  prodUrl: prodUrl_0_0_0_5,
  path: "/erp/Supply/SupplyList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_5,
  paramNames: [],
  queryNames: [
    "reject_accept",
    "special_sale",
    "goods_exempt_examine",
    "supply_character",
    "supply_level",
    "is_return_profit",
    "clearing_form",
    "period_profit",
    "pre_storage_admin",
    "is_participation_dispense",
    "is_sign_pingan_agreement",
    "take_stock_on_plan",
    "is_authentication",
    "is_offsite",
    "billing_type",
  ],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getSupplyList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 供应商列表 的 **请求函数**
 *
 * @分类 退换货是否接收
 * @请求头 `GET /erp/Supply/SupplyList`
 */
export const getSupplyList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getSupplyListRequestConfig, requestData), ...args);
};
getSupplyList.requestConfig = getSupplyListRequestConfig;
const mockUrl_0_0_0_6 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_6 = "";
const prodUrl_0_0_0_6 = "";
const dataKey_0_0_0_6 = "data";
/**
 * 接口 设置供应商商家性质 的 **请求配置**
 *
 * @分类 买手小店
 * @请求头 `POST /erp/Supply/setSupplyCharacter`
 */
const postSetSupplyCharacterRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_6,
  devUrl: devUrl_0_0_0_6,
  prodUrl: prodUrl_0_0_0_6,
  path: "/erp/Supply/setSupplyCharacter",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetSupplyCharacter",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置供应商商家性质 的 **请求函数**
 *
 * @分类 买手小店
 * @请求头 `POST /erp/Supply/setSupplyCharacter`
 */
export const postSetSupplyCharacter = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetSupplyCharacterRequestConfig, requestData),
    ...args
  );
};
postSetSupplyCharacter.requestConfig = postSetSupplyCharacterRequestConfig;
const mockUrl_0_0_0_7 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_7 = "";
const prodUrl_0_0_0_7 = "";
const dataKey_0_0_0_7 = "data";
/**
 * 接口 修改供应商经营信息 的 **请求配置**
 *
 * @分类 供应商合同管理
 * @请求头 `POST /erp/supply/updateManagement`
 */
const postUpdateManagementRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_7,
  devUrl: devUrl_0_0_0_7,
  prodUrl: prodUrl_0_0_0_7,
  path: "/erp/supply/updateManagement",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdateManagement",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 修改供应商经营信息 的 **请求函数**
 *
 * @分类 供应商合同管理
 * @请求头 `POST /erp/supply/updateManagement`
 */
export const postUpdateManagement = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postUpdateManagementRequestConfig, requestData),
    ...args
  );
};
postUpdateManagement.requestConfig = postUpdateManagementRequestConfig;
/**
 * 接口 查询供应商经营信息 的 **请求配置**
 *
 * @分类 供应商合同管理
 * @请求头 `POST /erp/supply/getManagement`
 */
const postGetManagementRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_7,
  devUrl: devUrl_0_0_0_7,
  prodUrl: prodUrl_0_0_0_7,
  path: "/erp/supply/getManagement",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetManagement",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 查询供应商经营信息 的 **请求函数**
 *
 * @分类 供应商合同管理
 * @请求头 `POST /erp/supply/getManagement`
 */
export const postGetManagement = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetManagementRequestConfig, requestData), ...args);
};
postGetManagement.requestConfig = postGetManagementRequestConfig;
/**
 * 接口 导出供应商合同信息 的 **请求配置**
 *
 * @分类 供应商合同管理
 * @请求头 `POST /erp/supply/exportSupplyContract`
 */
const postExportSupplyContractRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_7,
  devUrl: devUrl_0_0_0_7,
  prodUrl: prodUrl_0_0_0_7,
  path: "/erp/supply/exportSupplyContract",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportSupplyContract",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出供应商合同信息 的 **请求函数**
 *
 * @分类 供应商合同管理
 * @请求头 `POST /erp/supply/exportSupplyContract`
 */
export const postExportSupplyContract = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportSupplyContractRequestConfig, requestData),
    ...args
  );
};
postExportSupplyContract.requestConfig = postExportSupplyContractRequestConfig;
const mockUrl_0_0_0_8 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_8 = "";
const prodUrl_0_0_0_8 = "";
const dataKey_0_0_0_8 = "data";
/**
 * 接口 更新平台化信息 的 **请求配置**
 *
 * @分类 爆版4.23.0
 * @请求头 `POST /erp/Supply/saveSupplyPlatformInfo`
 */
const postSaveSupplyPlatformInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_8,
  devUrl: devUrl_0_0_0_8,
  prodUrl: prodUrl_0_0_0_8,
  path: "/erp/Supply/saveSupplyPlatformInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSaveSupplyPlatformInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 更新平台化信息 的 **请求函数**
 *
 * @分类 爆版4.23.0
 * @请求头 `POST /erp/Supply/saveSupplyPlatformInfo`
 */
export const postSaveSupplyPlatformInfo = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSaveSupplyPlatformInfoRequestConfig, requestData),
    ...args
  );
};
postSaveSupplyPlatformInfo.requestConfig =
  postSaveSupplyPlatformInfoRequestConfig;
/**
 * 接口 获取平台化信息 的 **请求配置**
 *
 * @分类 爆版4.23.0
 * @请求头 `POST /erp/Supply/getSupplyPlatformInfo`
 */
const postGetSupplyPlatformInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_8,
  devUrl: devUrl_0_0_0_8,
  prodUrl: prodUrl_0_0_0_8,
  path: "/erp/Supply/getSupplyPlatformInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSupplyPlatformInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取平台化信息 的 **请求函数**
 *
 * @分类 爆版4.23.0
 * @请求头 `POST /erp/Supply/getSupplyPlatformInfo`
 */
export const postGetSupplyPlatformInfo = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetSupplyPlatformInfoRequestConfig, requestData),
    ...args
  );
};
postGetSupplyPlatformInfo.requestConfig =
  postGetSupplyPlatformInfoRequestConfig;
const mockUrl_0_0_0_9 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_9 = "";
const prodUrl_0_0_0_9 = "";
const dataKey_0_0_0_9 = "data";
/**
 * 接口 根据城市获取主市场列表 的 **请求配置**
 *
 * @分类 获取“主市场”ID
 * @请求头 `POST /erp/Supply/getMainMarket`
 */
const postGetMainMarketRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/Supply/getMainMarket",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetMainMarket",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 根据城市获取主市场列表 的 **请求函数**
 *
 * @分类 获取“主市场”ID
 * @请求头 `POST /erp/Supply/getMainMarket`
 */
export const postGetMainMarket = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetMainMarketRequestConfig, requestData), ...args);
};
postGetMainMarket.requestConfig = postGetMainMarketRequestConfig;
/**
 * 接口 获取子市场列表 的 **请求配置**
 *
 * @分类 获取“主市场”ID
 * @请求头 `POST /erp/Supply/getChildMarket`
 */
const postGetChildMarketRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/Supply/getChildMarket",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetChildMarket",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取子市场列表 的 **请求函数**
 *
 * @分类 获取“主市场”ID
 * @请求头 `POST /erp/Supply/getChildMarket`
 */
export const postGetChildMarket = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetChildMarketRequestConfig, requestData),
    ...args
  );
};
postGetChildMarket.requestConfig = postGetChildMarketRequestConfig;
const mockUrl_0_0_0_10 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_10 = "";
const prodUrl_0_0_0_10 = "";
const dataKey_0_0_0_10 = "data";
/**
 * 接口 获取爆版绑定供应商的商品列表 的 **请求配置**
 *
 * @分类 5019
 * @请求头 `POST /erp/Supply/getBaobShopList`
 */
const postGetBaobShopListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_10,
  devUrl: devUrl_0_0_0_10,
  prodUrl: prodUrl_0_0_0_10,
  path: "/erp/Supply/getBaobShopList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetBaobShopList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取爆版绑定供应商的商品列表 的 **请求函数**
 *
 * @分类 5019
 * @请求头 `POST /erp/Supply/getBaobShopList`
 */
export const postGetBaobShopList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetBaobShopListRequestConfig, requestData),
    ...args
  );
};
postGetBaobShopList.requestConfig = postGetBaobShopListRequestConfig;
const mockUrl_0_0_0_11 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_11 = "";
const prodUrl_0_0_0_11 = "";
const dataKey_0_0_0_11 = "data";
/**
 * 接口 获取所有启用的业绩归属市场 的 **请求配置**
 *
 * @分类 #4334
 * @请求头 `GET /erp/Supply/getAttributableMarketList`
 */
const getGetAttributableMarketListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_11,
  devUrl: devUrl_0_0_0_11,
  prodUrl: prodUrl_0_0_0_11,
  path: "/erp/Supply/getAttributableMarketList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetAttributableMarketList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取所有启用的业绩归属市场 的 **请求函数**
 *
 * @分类 #4334
 * @请求头 `GET /erp/Supply/getAttributableMarketList`
 */
export const getGetAttributableMarketList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getGetAttributableMarketListRequestConfig, requestData),
    ...args
  );
};
getGetAttributableMarketList.requestConfig =
  getGetAttributableMarketListRequestConfig;
/**
 * 接口 批量绑定业绩归属市场 的 **请求配置**
 *
 * @分类 #4334
 * @请求头 `POST /erp/Supply/batchBindAttributableMarket`
 */
const postBatchBindAttributableMarketRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_11,
  devUrl: devUrl_0_0_0_11,
  prodUrl: prodUrl_0_0_0_11,
  path: "/erp/Supply/batchBindAttributableMarket",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchBindAttributableMarket",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量绑定业绩归属市场 的 **请求函数**
 *
 * @分类 #4334
 * @请求头 `POST /erp/Supply/batchBindAttributableMarket`
 */
export const postBatchBindAttributableMarket = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postBatchBindAttributableMarketRequestConfig, requestData),
    ...args
  );
};
postBatchBindAttributableMarket.requestConfig =
  postBatchBindAttributableMarketRequestConfig;
const mockUrl_0_0_0_12 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_12 = "";
const prodUrl_0_0_0_12 = "";
const dataKey_0_0_0_12 = "data";
/**
 * 接口 模糊搜索内部已启用的员工 的 **请求配置**
 *
 * @分类 #4257
 * @请求头 `POST /erp/Supply/searchEnabledAdminByNameLike`
 */
const postSearchEnabledAdminByNameLikeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_12,
  devUrl: devUrl_0_0_0_12,
  prodUrl: prodUrl_0_0_0_12,
  path: "/erp/Supply/searchEnabledAdminByNameLike",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_12,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSearchEnabledAdminByNameLike",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 模糊搜索内部已启用的员工 的 **请求函数**
 *
 * @分类 #4257
 * @请求头 `POST /erp/Supply/searchEnabledAdminByNameLike`
 */
export const postSearchEnabledAdminByNameLike = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSearchEnabledAdminByNameLikeRequestConfig, requestData),
    ...args
  );
};
postSearchEnabledAdminByNameLike.requestConfig =
  postSearchEnabledAdminByNameLikeRequestConfig;
/**
 * 接口 返回所有已启用的员工 的 **请求配置**
 *
 * @分类 #4257
 * @请求头 `POST /erp/supply/getAllEnableAdmin`
 */
const postGetAllEnableAdminRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_12,
  devUrl: devUrl_0_0_0_12,
  prodUrl: prodUrl_0_0_0_12,
  path: "/erp/supply/getAllEnableAdmin",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_12,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetAllEnableAdmin",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 返回所有已启用的员工 的 **请求函数**
 *
 * @分类 #4257
 * @请求头 `POST /erp/supply/getAllEnableAdmin`
 */
export const postGetAllEnableAdmin = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetAllEnableAdminRequestConfig, requestData),
    ...args
  );
};
postGetAllEnableAdmin.requestConfig = postGetAllEnableAdminRequestConfig;
/**
 * 接口 批量绑定商家运营跟进人 的 **请求配置**
 *
 * @分类 #4257
 * @请求头 `POST /erp/Supply/batchUpdateFollowerAdmin`
 */
const postBatchUpdateFollowerAdminRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_12,
  devUrl: devUrl_0_0_0_12,
  prodUrl: prodUrl_0_0_0_12,
  path: "/erp/Supply/batchUpdateFollowerAdmin",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_12,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchUpdateFollowerAdmin",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量绑定商家运营跟进人 的 **请求函数**
 *
 * @分类 #4257
 * @请求头 `POST /erp/Supply/batchUpdateFollowerAdmin`
 */
export const postBatchUpdateFollowerAdmin = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postBatchUpdateFollowerAdminRequestConfig, requestData),
    ...args
  );
};
postBatchUpdateFollowerAdmin.requestConfig =
  postBatchUpdateFollowerAdminRequestConfig;
const mockUrl_0_0_0_13 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_13 = "";
const prodUrl_0_0_0_13 = "";
const dataKey_0_0_0_13 = "data";
/**
 * 接口 前置仓邀约池规则配置 导入 的 **请求配置**
 *
 * @分类 #4101
 * @请求头 `POST /erp/Supply/importInvitationRule`
 */
const postImportInvitationRuleRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_13,
  devUrl: devUrl_0_0_0_13,
  prodUrl: prodUrl_0_0_0_13,
  path: "/erp/Supply/importInvitationRule",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportInvitationRule",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 前置仓邀约池规则配置 导入 的 **请求函数**
 *
 * @分类 #4101
 * @请求头 `POST /erp/Supply/importInvitationRule`
 */
export const postImportInvitationRule = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportInvitationRuleRequestConfig, requestData),
    ...args
  );
};
postImportInvitationRule.requestConfig = postImportInvitationRuleRequestConfig;
/**
 * 接口 前置仓邀约池规则配置 导出 的 **请求配置**
 *
 * @分类 #4101
 * @请求头 `POST /erp/Supply/exportInvitationRule`
 */
const postExportInvitationRuleRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_13,
  devUrl: devUrl_0_0_0_13,
  prodUrl: prodUrl_0_0_0_13,
  path: "/erp/Supply/exportInvitationRule",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportInvitationRule",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 前置仓邀约池规则配置 导出 的 **请求函数**
 *
 * @分类 #4101
 * @请求头 `POST /erp/Supply/exportInvitationRule`
 */
export const postExportInvitationRule = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportInvitationRuleRequestConfig, requestData),
    ...args
  );
};
postExportInvitationRule.requestConfig = postExportInvitationRuleRequestConfig;
const mockUrl_0_0_0_14 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_14 = "";
const prodUrl_0_0_0_14 = "";
const dataKey_0_0_0_14 = "data";
/**
 * 接口 导出专场当天报单白名单 的 **请求配置**
 *
 * @分类 4252
 * @请求头 `GET /erp/Supply/exportAutoStockPlan`
 */
const getExportAutoStockPlanRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_14,
  devUrl: devUrl_0_0_0_14,
  prodUrl: prodUrl_0_0_0_14,
  path: "/erp/Supply/exportAutoStockPlan",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getExportAutoStockPlan",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出专场当天报单白名单 的 **请求函数**
 *
 * @分类 4252
 * @请求头 `GET /erp/Supply/exportAutoStockPlan`
 */
export const getExportAutoStockPlan = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getExportAutoStockPlanRequestConfig, requestData),
    ...args
  );
};
getExportAutoStockPlan.requestConfig = getExportAutoStockPlanRequestConfig;
/**
 * 接口 导入专场当天报单白名单 的 **请求配置**
 *
 * @分类 4252
 * @请求头 `POST /erp/Supply/importAutoStockPlan`
 */
const postImportAutoStockPlanRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_14,
  devUrl: devUrl_0_0_0_14,
  prodUrl: prodUrl_0_0_0_14,
  path: "/erp/Supply/importAutoStockPlan",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportAutoStockPlan",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入专场当天报单白名单 的 **请求函数**
 *
 * @分类 4252
 * @请求头 `POST /erp/Supply/importAutoStockPlan`
 */
export const postImportAutoStockPlan = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postImportAutoStockPlanRequestConfig, requestData),
    ...args
  );
};
postImportAutoStockPlan.requestConfig = postImportAutoStockPlanRequestConfig;
/**
 * 接口 导入 - 专场当天报单黑名单 的 **请求配置**
 *
 * @分类 4252
 * @请求头 `POST /erp/Supply/importBlackDayReport`
 */
const postImportBlackDayReportRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_14,
  devUrl: devUrl_0_0_0_14,
  prodUrl: prodUrl_0_0_0_14,
  path: "/erp/Supply/importBlackDayReport",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportBlackDayReport",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入 - 专场当天报单黑名单 的 **请求函数**
 *
 * @分类 4252
 * @请求头 `POST /erp/Supply/importBlackDayReport`
 */
export const postImportBlackDayReport = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportBlackDayReportRequestConfig, requestData),
    ...args
  );
};
postImportBlackDayReport.requestConfig = postImportBlackDayReportRequestConfig;
/**
 * 接口 导出 - 专场当天报单黑名单 的 **请求配置**
 *
 * @分类 4252
 * @请求头 `POST /erp/Supply/exportBlackDayReport`
 */
const postExportBlackDayReportRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_14,
  devUrl: devUrl_0_0_0_14,
  prodUrl: prodUrl_0_0_0_14,
  path: "/erp/Supply/exportBlackDayReport",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportBlackDayReport",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出 - 专场当天报单黑名单 的 **请求函数**
 *
 * @分类 4252
 * @请求头 `POST /erp/Supply/exportBlackDayReport`
 */
export const postExportBlackDayReport = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportBlackDayReportRequestConfig, requestData),
    ...args
  );
};
postExportBlackDayReport.requestConfig = postExportBlackDayReportRequestConfig;
const mockUrl_0_0_0_15 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_15 = "";
const prodUrl_0_0_0_15 = "";
const dataKey_0_0_0_15 = "data";
/**
 * 接口 校验店铺是否可绑定 的 **请求配置**
 *
 * @分类 #4692
 * @请求头 `POST /erp/Supply/checkShop`
 */
const postCheckShopRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_15,
  devUrl: devUrl_0_0_0_15,
  prodUrl: prodUrl_0_0_0_15,
  path: "/erp/Supply/checkShop",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCheckShop",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 校验店铺是否可绑定 的 **请求函数**
 *
 * @分类 #4692
 * @请求头 `POST /erp/Supply/checkShop`
 */
export const postCheckShop = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postCheckShopRequestConfig, requestData), ...args);
};
postCheckShop.requestConfig = postCheckShopRequestConfig;
const mockUrl_0_0_0_16 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_16 = "";
const prodUrl_0_0_0_16 = "";
const dataKey_0_0_0_16 = "data";
/**
 * 接口 批量处理能否参与特价销售 的 **请求配置**
 *
 * @分类 #4606
 * @请求头 `POST /erp/Supply/batchUpdateSpecialSaleStatus`
 */
const postBatchUpdateSpecialSaleStatusRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_16,
  devUrl: devUrl_0_0_0_16,
  prodUrl: prodUrl_0_0_0_16,
  path: "/erp/Supply/batchUpdateSpecialSaleStatus",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchUpdateSpecialSaleStatus",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量处理能否参与特价销售 的 **请求函数**
 *
 * @分类 #4606
 * @请求头 `POST /erp/Supply/batchUpdateSpecialSaleStatus`
 */
export const postBatchUpdateSpecialSaleStatus = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postBatchUpdateSpecialSaleStatusRequestConfig, requestData),
    ...args
  );
};
postBatchUpdateSpecialSaleStatus.requestConfig =
  postBatchUpdateSpecialSaleStatusRequestConfig;
const mockUrl_0_0_0_17 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_17 = "";
const prodUrl_0_0_0_17 = "";
const dataKey_0_0_0_17 = "data";
/**
 * 接口 导入 - 特殊货期黑名单 的 **请求配置**
 *
 * @分类 #5426
 * @请求头 `POST /erp/Supply/importSpecialDeliveryBlackList`
 */
const postImportSpecialDeliveryBlackListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_17,
  devUrl: devUrl_0_0_0_17,
  prodUrl: prodUrl_0_0_0_17,
  path: "/erp/Supply/importSpecialDeliveryBlackList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_17,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportSpecialDeliveryBlackList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入 - 特殊货期黑名单 的 **请求函数**
 *
 * @分类 #5426
 * @请求头 `POST /erp/Supply/importSpecialDeliveryBlackList`
 */
export const postImportSpecialDeliveryBlackList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportSpecialDeliveryBlackListRequestConfig, requestData),
    ...args
  );
};
postImportSpecialDeliveryBlackList.requestConfig =
  postImportSpecialDeliveryBlackListRequestConfig;
/**
 * 接口 导出 - 特殊货期黑名单 的 **请求配置**
 *
 * @分类 #5426
 * @请求头 `POST /erp/Supply/exportSpecialDeliveryBlackList`
 */
const postExportSpecialDeliveryBlackListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_17,
  devUrl: devUrl_0_0_0_17,
  prodUrl: prodUrl_0_0_0_17,
  path: "/erp/Supply/exportSpecialDeliveryBlackList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_17,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportSpecialDeliveryBlackList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出 - 特殊货期黑名单 的 **请求函数**
 *
 * @分类 #5426
 * @请求头 `POST /erp/Supply/exportSpecialDeliveryBlackList`
 */
export const postExportSpecialDeliveryBlackList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportSpecialDeliveryBlackListRequestConfig, requestData),
    ...args
  );
};
postExportSpecialDeliveryBlackList.requestConfig =
  postExportSpecialDeliveryBlackListRequestConfig;
/**
 * 接口 导入批量修改 的 **请求配置**
 *
 * @分类 #5426
 * @请求头 `POST /erp/Supply/importSupplyUpdateFile`
 */
const postImportSupplyUpdateFileRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_17,
  devUrl: devUrl_0_0_0_17,
  prodUrl: prodUrl_0_0_0_17,
  path: "/erp/Supply/importSupplyUpdateFile",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_17,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportSupplyUpdateFile",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入批量修改 的 **请求函数**
 *
 * @分类 #5426
 * @请求头 `POST /erp/Supply/importSupplyUpdateFile`
 */
export const postImportSupplyUpdateFile = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportSupplyUpdateFileRequestConfig, requestData),
    ...args
  );
};
postImportSupplyUpdateFile.requestConfig =
  postImportSupplyUpdateFileRequestConfig;
/**
 * 接口 导出 - 承诺库存黑名单 的 **请求配置**
 *
 * @分类 #5426
 * @请求头 `POST /erp/Supply/exportCommittedSpotBlacklist`
 */
const postExportCommittedSpotBlacklistRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_17,
  devUrl: devUrl_0_0_0_17,
  prodUrl: prodUrl_0_0_0_17,
  path: "/erp/Supply/exportCommittedSpotBlacklist",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_17,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportCommittedSpotBlacklist",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出 - 承诺库存黑名单 的 **请求函数**
 *
 * @分类 #5426
 * @请求头 `POST /erp/Supply/exportCommittedSpotBlacklist`
 */
export const postExportCommittedSpotBlacklist = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportCommittedSpotBlacklistRequestConfig, requestData),
    ...args
  );
};
postExportCommittedSpotBlacklist.requestConfig =
  postExportCommittedSpotBlacklistRequestConfig;
/**
 * 接口 导入 - 承诺库存黑名单 的 **请求配置**
 *
 * @分类 #5426
 * @请求头 `POST /erp/Supply/importCommittedSpotBlacklist`
 */
const postImportCommittedSpotBlacklistRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_17,
  devUrl: devUrl_0_0_0_17,
  prodUrl: prodUrl_0_0_0_17,
  path: "/erp/Supply/importCommittedSpotBlacklist",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_17,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportCommittedSpotBlacklist",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入 - 承诺库存黑名单 的 **请求函数**
 *
 * @分类 #5426
 * @请求头 `POST /erp/Supply/importCommittedSpotBlacklist`
 */
export const postImportCommittedSpotBlacklist = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportCommittedSpotBlacklistRequestConfig, requestData),
    ...args
  );
};
postImportCommittedSpotBlacklist.requestConfig =
  postImportCommittedSpotBlacklistRequestConfig;
const mockUrl_0_0_0_18 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_18 = "";
const prodUrl_0_0_0_18 = "";
const dataKey_0_0_0_18 = "data";
/**
 * 接口 导入 - 仓库用户长期备注 的 **请求配置**
 *
 * @分类 #5509
 * @请求头 `POST /erp/Supply/importUsersRemarks`
 */
const postImportUsersRemarksRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_18,
  devUrl: devUrl_0_0_0_18,
  prodUrl: prodUrl_0_0_0_18,
  path: "/erp/Supply/importUsersRemarks",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_18,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportUsersRemarks",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入 - 仓库用户长期备注 的 **请求函数**
 *
 * @分类 #5509
 * @请求头 `POST /erp/Supply/importUsersRemarks`
 */
export const postImportUsersRemarks = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postImportUsersRemarksRequestConfig, requestData),
    ...args
  );
};
postImportUsersRemarks.requestConfig = postImportUsersRemarksRequestConfig;
/**
 * 接口 导出 - 仓库用户长期备注 的 **请求配置**
 *
 * @分类 #5509
 * @请求头 `POST /erp/Supply/exportUserRemark`
 */
const postExportUserRemarkRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_18,
  devUrl: devUrl_0_0_0_18,
  prodUrl: prodUrl_0_0_0_18,
  path: "/erp/Supply/exportUserRemark",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_18,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportUserRemark",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出 - 仓库用户长期备注 的 **请求函数**
 *
 * @分类 #5509
 * @请求头 `POST /erp/Supply/exportUserRemark`
 */
export const postExportUserRemark = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postExportUserRemarkRequestConfig, requestData),
    ...args
  );
};
postExportUserRemark.requestConfig = postExportUserRemarkRequestConfig;
const mockUrl_0_0_0_19 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_19 = "";
const prodUrl_0_0_0_19 = "";
const dataKey_0_0_0_19 = "data";
/**
 * 接口 批量绑定次品员 的 **请求配置**
 *
 * @分类 #5491
 * @请求头 `POST /erp/Supply/SupplyBindDgGroupAndMember`
 */
const postSupplyBindDgGroupAndMemberRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_19,
  devUrl: devUrl_0_0_0_19,
  prodUrl: prodUrl_0_0_0_19,
  path: "/erp/Supply/SupplyBindDgGroupAndMember",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_19,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSupplyBindDgGroupAndMember",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量绑定次品员 的 **请求函数**
 *
 * @分类 #5491
 * @请求头 `POST /erp/Supply/SupplyBindDgGroupAndMember`
 */
export const postSupplyBindDgGroupAndMember = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSupplyBindDgGroupAndMemberRequestConfig, requestData),
    ...args
  );
};
postSupplyBindDgGroupAndMember.requestConfig =
  postSupplyBindDgGroupAndMemberRequestConfig;
/**
 * 接口 批量绑定采购员 的 **请求配置**
 *
 * @分类 #5491
 * @请求头 `POST /erp/Supply/SupplyBindPgMember`
 */
const postSupplyBindPgMemberRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_19,
  devUrl: devUrl_0_0_0_19,
  prodUrl: prodUrl_0_0_0_19,
  path: "/erp/Supply/SupplyBindPgMember",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_19,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSupplyBindPgMember",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量绑定采购员 的 **请求函数**
 *
 * @分类 #5491
 * @请求头 `POST /erp/Supply/SupplyBindPgMember`
 */
export const postSupplyBindPgMember = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSupplyBindPgMemberRequestConfig, requestData),
    ...args
  );
};
postSupplyBindPgMember.requestConfig = postSupplyBindPgMemberRequestConfig;
/**
 * 接口 批量修改买手组和买手 的 **请求配置**
 *
 * @分类 #5491
 * @请求头 `POST /erp/Supply/batchUpdatePickerInfo`
 */
const postBatchUpdatePickerInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_19,
  devUrl: devUrl_0_0_0_19,
  prodUrl: prodUrl_0_0_0_19,
  path: "/erp/Supply/batchUpdatePickerInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_19,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchUpdatePickerInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量修改买手组和买手 的 **请求函数**
 *
 * @分类 #5491
 * @请求头 `POST /erp/Supply/batchUpdatePickerInfo`
 */
export const postBatchUpdatePickerInfo = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postBatchUpdatePickerInfoRequestConfig, requestData),
    ...args
  );
};
postBatchUpdatePickerInfo.requestConfig =
  postBatchUpdatePickerInfoRequestConfig;
/**
 * 接口 批量修改市场和子市场 的 **请求配置**
 *
 * @分类 #5491
 * @请求头 `POST /erp/Supply/batchUpdateMarket`
 */
const postBatchUpdateMarketRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_19,
  devUrl: devUrl_0_0_0_19,
  prodUrl: prodUrl_0_0_0_19,
  path: "/erp/Supply/batchUpdateMarket",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_19,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchUpdateMarket",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量修改市场和子市场 的 **请求函数**
 *
 * @分类 #5491
 * @请求头 `POST /erp/Supply/batchUpdateMarket`
 */
export const postBatchUpdateMarket = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postBatchUpdateMarketRequestConfig, requestData),
    ...args
  );
};
postBatchUpdateMarket.requestConfig = postBatchUpdateMarketRequestConfig;
const mockUrl_0_0_0_20 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_20 = "";
const prodUrl_0_0_0_20 = "";
const dataKey_0_0_0_20 = "data";
/**
 * 接口 商家服务分-保存服务分配置 的 **请求配置**
 *
 * @分类 4.56.0
 * @请求头 `POST /erp/supply/saveSupplyServiceConfig`
 */
const postSaveSupplyServiceConfigRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_20,
  devUrl: devUrl_0_0_0_20,
  prodUrl: prodUrl_0_0_0_20,
  path: "/erp/supply/saveSupplyServiceConfig",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_20,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSaveSupplyServiceConfig",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家服务分-保存服务分配置 的 **请求函数**
 *
 * @分类 4.56.0
 * @请求头 `POST /erp/supply/saveSupplyServiceConfig`
 */
export const postSaveSupplyServiceConfig = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSaveSupplyServiceConfigRequestConfig, requestData),
    ...args
  );
};
postSaveSupplyServiceConfig.requestConfig =
  postSaveSupplyServiceConfigRequestConfig;
/**
 * 接口 商家服务分-获取服务分配置 的 **请求配置**
 *
 * @分类 4.56.0
 * @请求头 `POST /erp/supply/getSupplyServiceConfig`
 */
const postGetSupplyServiceConfigRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_20,
  devUrl: devUrl_0_0_0_20,
  prodUrl: prodUrl_0_0_0_20,
  path: "/erp/supply/getSupplyServiceConfig",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_20,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSupplyServiceConfig",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家服务分-获取服务分配置 的 **请求函数**
 *
 * @分类 4.56.0
 * @请求头 `POST /erp/supply/getSupplyServiceConfig`
 */
export const postGetSupplyServiceConfig = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetSupplyServiceConfigRequestConfig, requestData),
    ...args
  );
};
postGetSupplyServiceConfig.requestConfig =
  postGetSupplyServiceConfigRequestConfig;
/**
 * 接口 商家服务分-导入加分商家名单  的 **请求配置**
 *
 * @分类 4.56.0
 * @请求头 `POST /erp/supply/importBonusPointsSupply`
 */
const postImportBonusPointsSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_20,
  devUrl: devUrl_0_0_0_20,
  prodUrl: prodUrl_0_0_0_20,
  path: "/erp/supply/importBonusPointsSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_20,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportBonusPointsSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家服务分-导入加分商家名单  的 **请求函数**
 *
 * @分类 4.56.0
 * @请求头 `POST /erp/supply/importBonusPointsSupply`
 */
export const postImportBonusPointsSupply = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportBonusPointsSupplyRequestConfig, requestData),
    ...args
  );
};
postImportBonusPointsSupply.requestConfig =
  postImportBonusPointsSupplyRequestConfig;
/**
 * 接口 商家服务分-获取商家服务分配置日志 的 **请求配置**
 *
 * @分类 4.56.0
 * @请求头 `POST /erp/supply/getSupplyServiceConfigLog`
 */
const postGetSupplyServiceConfigLogRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_20,
  devUrl: devUrl_0_0_0_20,
  prodUrl: prodUrl_0_0_0_20,
  path: "/erp/supply/getSupplyServiceConfigLog",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_20,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSupplyServiceConfigLog",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家服务分-获取商家服务分配置日志 的 **请求函数**
 *
 * @分类 4.56.0
 * @请求头 `POST /erp/supply/getSupplyServiceConfigLog`
 */
export const postGetSupplyServiceConfigLog = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetSupplyServiceConfigLogRequestConfig, requestData),
    ...args
  );
};
postGetSupplyServiceConfigLog.requestConfig =
  postGetSupplyServiceConfigLogRequestConfig;
/**
 * 接口 商家服务分-导入解除加分名单 的 **请求配置**
 *
 * @分类 4.56.0
 * @请求头 `POST /erp/supply/importLiftBonusPointsSupply`
 */
const postImportLiftBonusPointsSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_20,
  devUrl: devUrl_0_0_0_20,
  prodUrl: prodUrl_0_0_0_20,
  path: "/erp/supply/importLiftBonusPointsSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_20,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportLiftBonusPointsSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家服务分-导入解除加分名单 的 **请求函数**
 *
 * @分类 4.56.0
 * @请求头 `POST /erp/supply/importLiftBonusPointsSupply`
 */
export const postImportLiftBonusPointsSupply = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportLiftBonusPointsSupplyRequestConfig, requestData),
    ...args
  );
};
postImportLiftBonusPointsSupply.requestConfig =
  postImportLiftBonusPointsSupplyRequestConfig;
/**
 * 接口 商家服务分-导出加分商家名单 的 **请求配置**
 *
 * @分类 4.56.0
 * @请求头 `POST /erp/supply/exportBonusPointsSupply`
 */
const postExportBonusPointsSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_20,
  devUrl: devUrl_0_0_0_20,
  prodUrl: prodUrl_0_0_0_20,
  path: "/erp/supply/exportBonusPointsSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_20,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportBonusPointsSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家服务分-导出加分商家名单 的 **请求函数**
 *
 * @分类 4.56.0
 * @请求头 `POST /erp/supply/exportBonusPointsSupply`
 */
export const postExportBonusPointsSupply = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportBonusPointsSupplyRequestConfig, requestData),
    ...args
  );
};
postExportBonusPointsSupply.requestConfig =
  postExportBonusPointsSupplyRequestConfig;
const mockUrl_0_0_0_21 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_21 = "";
const prodUrl_0_0_0_21 = "";
const dataKey_0_0_0_21 = "data";
/**
 * 接口 供应商列表筛选条件 的 **请求配置**
 *
 * @分类 #4424
 * @请求头 `GET /erp/Supply/optionsForSupplyList`
 */
const getOptionsForSupplyListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_21,
  devUrl: devUrl_0_0_0_21,
  prodUrl: prodUrl_0_0_0_21,
  path: "/erp/Supply/optionsForSupplyList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_21,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getOptionsForSupplyList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 供应商列表筛选条件 的 **请求函数**
 *
 * @分类 #4424
 * @请求头 `GET /erp/Supply/optionsForSupplyList`
 */
export const getOptionsForSupplyList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getOptionsForSupplyListRequestConfig, requestData),
    ...args
  );
};
getOptionsForSupplyList.requestConfig = getOptionsForSupplyListRequestConfig;
const mockUrl_0_0_0_22 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_22 = "";
const prodUrl_0_0_0_22 = "";
const dataKey_0_0_0_22 = "data";
/**
 * 接口 批量修改商家权限 的 **请求配置**
 *
 * @分类 4.55.0
 * @请求头 `POST /erp/Supply/batchEditLimitsAuthority`
 */
const postBatchEditLimitsAuthorityRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_22,
  devUrl: devUrl_0_0_0_22,
  prodUrl: prodUrl_0_0_0_22,
  path: "/erp/Supply/batchEditLimitsAuthority",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_22,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchEditLimitsAuthority",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量修改商家权限 的 **请求函数**
 *
 * @分类 4.55.0
 * @请求头 `POST /erp/Supply/batchEditLimitsAuthority`
 */
export const postBatchEditLimitsAuthority = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postBatchEditLimitsAuthorityRequestConfig, requestData),
    ...args
  );
};
postBatchEditLimitsAuthority.requestConfig =
  postBatchEditLimitsAuthorityRequestConfig;
const mockUrl_0_0_0_23 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_23 = "";
const prodUrl_0_0_0_23 = "";
const dataKey_0_0_0_23 = "data";
/**
 * 接口 商家列表导出 的 **请求配置**
 *
 * @分类 5841
 * @请求头 `POST /erp/Supply/exportSupply`
 */
const postExportSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_23,
  devUrl: devUrl_0_0_0_23,
  prodUrl: prodUrl_0_0_0_23,
  path: "/erp/Supply/exportSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_23,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家列表导出 的 **请求函数**
 *
 * @分类 5841
 * @请求头 `POST /erp/Supply/exportSupply`
 */
export const postExportSupply = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postExportSupplyRequestConfig, requestData), ...args);
};
postExportSupply.requestConfig = postExportSupplyRequestConfig;
const mockUrl_0_0_0_25 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_25 = "";
const prodUrl_0_0_0_25 = "";
const dataKey_0_0_0_25 = "data";
/**
 * 接口 批量导入商家无数据寄回信息 的 **请求配置**
 *
 * @分类 #5719
 * @请求头 `POST /erp/Supply/importNoDataReturnData`
 */
const postImportNoDataReturnDataRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_25,
  devUrl: devUrl_0_0_0_25,
  prodUrl: prodUrl_0_0_0_25,
  path: "/erp/Supply/importNoDataReturnData",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_25,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportNoDataReturnData",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量导入商家无数据寄回信息 的 **请求函数**
 *
 * @分类 #5719
 * @请求头 `POST /erp/Supply/importNoDataReturnData`
 */
export const postImportNoDataReturnData = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportNoDataReturnDataRequestConfig, requestData),
    ...args
  );
};
postImportNoDataReturnData.requestConfig =
  postImportNoDataReturnDataRequestConfig;
/**
 * 接口 下载批量导入商家无数据寄回信息模板 的 **请求配置**
 *
 * @分类 #5719
 * @请求头 `POST /erp/Supply/downNoDataReturnDataTemp`
 */
const postDownNoDataReturnDataTempRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_25,
  devUrl: devUrl_0_0_0_25,
  prodUrl: prodUrl_0_0_0_25,
  path: "/erp/Supply/downNoDataReturnDataTemp",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_25,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDownNoDataReturnDataTemp",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 下载批量导入商家无数据寄回信息模板 的 **请求函数**
 *
 * @分类 #5719
 * @请求头 `POST /erp/Supply/downNoDataReturnDataTemp`
 */
export const postDownNoDataReturnDataTemp = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postDownNoDataReturnDataTempRequestConfig, requestData),
    ...args
  );
};
postDownNoDataReturnDataTemp.requestConfig =
  postDownNoDataReturnDataTempRequestConfig;
const mockUrl_0_0_0_26 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_26 = "";
const prodUrl_0_0_0_26 = "";
const dataKey_0_0_0_26 = "data";
/**
 * 接口 批量修改退换货收货地址 的 **请求配置**
 *
 * @分类 #5947
 * @请求头 `POST /erp/Supply/importExchangeGoodsExpressBack`
 */
const postImportExchangeGoodsExpressBackRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_26,
  devUrl: devUrl_0_0_0_26,
  prodUrl: prodUrl_0_0_0_26,
  path: "/erp/Supply/importExchangeGoodsExpressBack",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_26,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportExchangeGoodsExpressBack",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量修改退换货收货地址 的 **请求函数**
 *
 * @分类 #5947
 * @请求头 `POST /erp/Supply/importExchangeGoodsExpressBack`
 */
export const postImportExchangeGoodsExpressBack = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportExchangeGoodsExpressBackRequestConfig, requestData),
    ...args
  );
};
postImportExchangeGoodsExpressBack.requestConfig =
  postImportExchangeGoodsExpressBackRequestConfig;
/**
 * 接口 批量修改退换货收货地址模板 的 **请求配置**
 *
 * @分类 #5947
 * @请求头 `POST /erp/Supply/exportExchangeGoodsExpressBackLink`
 */
const postExportExchangeGoodsExpressBackLinkRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_26,
  devUrl: devUrl_0_0_0_26,
  prodUrl: prodUrl_0_0_0_26,
  path: "/erp/Supply/exportExchangeGoodsExpressBackLink",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_26,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportExchangeGoodsExpressBackLink",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量修改退换货收货地址模板 的 **请求函数**
 *
 * @分类 #5947
 * @请求头 `POST /erp/Supply/exportExchangeGoodsExpressBackLink`
 */
export const postExportExchangeGoodsExpressBackLink = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportExchangeGoodsExpressBackLinkRequestConfig, requestData),
    ...args
  );
};
postExportExchangeGoodsExpressBackLink.requestConfig =
  postExportExchangeGoodsExpressBackLinkRequestConfig;
const mockUrl_0_0_0_27 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_27 = "";
const prodUrl_0_0_0_27 = "";
const dataKey_0_0_0_27 = "data";
/**
 * 接口 导入让利指定货号文件 的 **请求配置**
 *
 * @分类 4278
 * @请求头 `POST /erp/supply/importReturnProfitGoods`
 */
const postImportReturnProfitGoodsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_27,
  devUrl: devUrl_0_0_0_27,
  prodUrl: prodUrl_0_0_0_27,
  path: "/erp/supply/importReturnProfitGoods",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_27,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportReturnProfitGoods",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入让利指定货号文件 的 **请求函数**
 *
 * @分类 4278
 * @请求头 `POST /erp/supply/importReturnProfitGoods`
 */
export const postImportReturnProfitGoods = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportReturnProfitGoodsRequestConfig, requestData),
    ...args
  );
};
postImportReturnProfitGoods.requestConfig =
  postImportReturnProfitGoodsRequestConfig;
/**
 * 接口 新增商家信息 的 **请求配置**
 *
 * @分类 4278
 * @请求头 `POST /erp/supply/AddSupply`
 */
const postAddSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_27,
  devUrl: devUrl_0_0_0_27,
  prodUrl: prodUrl_0_0_0_27,
  path: "/erp/supply/AddSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_27,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postAddSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 新增商家信息 的 **请求函数**
 *
 * @分类 4278
 * @请求头 `POST /erp/supply/AddSupply`
 */
export const postAddSupply = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postAddSupplyRequestConfig, requestData), ...args);
};
postAddSupply.requestConfig = postAddSupplyRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/supply.js